/**
 * Development logger utility
 * Only logs in development environment to avoid console pollution in production
 */

type LogLevel = 'log' | 'warn' | 'error' | 'info';

interface Logger {
  log: (message: string, data?: any) => void;
  warn: (message: string, data?: any) => void;
  error: (message: string, error?: any) => void;
  info: (message: string, data?: any) => void;
}

const isDevelopment = process.env.NODE_ENV === 'development';

const logger: Logger = {
  log: (message: string, data?: any) => {
    if (isDevelopment) {
      console.log(message, data);
    }
  },
  warn: (message: string, data?: any) => {
    if (isDevelopment) {
      console.warn(message, data);
    }
  },
  error: (message: string, error?: any) => {
    if (isDevelopment) {
      console.error(message, error);
    }
  },
  info: (message: string, data?: any) => {
    if (isDevelopment) {
      console.info(message, data);
    }
  },
};

/**
 * Logs a failed API call without the request: an AxiosError carries `config.data`, which holds
 * passwords on the account actions, and the console is also a Sentry breadcrumb source (S-60).
 * Only the HTTP status and the backend error code are printed.
 */
export function logApiError(label: string, error: unknown): void {
  const response = (error as { response?: { status?: number; data?: { code?: string } } } | null)?.response;
  console.error(label, { status: response?.status ?? null, code: response?.data?.code ?? null });
}

export default logger;
